import "text-encoding-polyfill";
import Joi from "joi";

const logInSchema = Joi.object({
	email: Joi.string()
		.email({
			tlds: false,
		})
		.required(),
	password: Joi.string().min(5).max(20).required(),
});

export default logInSchema;
